import { render, staticRenderFns } from "./TtyLimChkList.vue?vue&type=template&id=038eb793&"
import script from "./TtyLimChkList.vue?vue&type=script&lang=js&"
export * from "./TtyLimChkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports